import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { formatDate } from "../../../../utils/date-converter";

const SalesReturnPDFInfo = ({ salesReturn, contact, docType }) => {
  const isCreditNote = docType === "credit_note";

  const renderAddressString = (addressValues) => {
    let result = "";

    if (Array.isArray(addressValues)) {
      addressValues.forEach((item) => {
        if (item.length > 0) {
          result = result + item + ", ";
        }
      });
    } else {
      const keys = Object.keys(addressValues);
      keys.forEach((key) => {
        if (addressValues[key].length > 0) {
          result = result + addressValues[key] + ", ";
        }
      });
    }
    if (result.trim().length === 0) {
      return "-";
    }
    // remove whitespace and last comma
    return result.trim().slice(0, -1);
  };

  const renderReferenceDocument = (referenceDocumentId) => {
    if (Array.isArray(referenceDocumentId)) {
      if (referenceDocumentId.length === 0) {
        return "-";
      }
      return referenceDocumentId
        .map((ref) => ref.reference_document_id)
        .join(", ");
    }
    if (typeof referenceDocumentId === "string" && referenceDocumentId) {
      return referenceDocumentId;
    }
    return "-";
  };

  let leftHeader;
  let leftInfo;
  let rightHeader;
  let rightInfo;

  if (isCreditNote) {
    leftHeader = [
      "รหัสลูกค้า / Customer ID",
      "ชื่อลูกค้า / Customer Name",
      "ที่อยู่ / Address",
      "เลขผู้เสียภาษี / Tax ID",
      "เบอร์โทรศัพท์ / Phone",
      "แฟกซ์ / Fax",
      "อีเมล / Email",
    ];

    leftInfo = [
      salesReturn?.contact_document_id || "-",
      contact?.contact_name || "-",
      renderAddressString(salesReturn?.customer?.billing_address || {}) || "",
      contact?.identity_no || "-",
      salesReturn?.customer?.phone || "-",
      salesReturn?.customer?.fax || "-",
      salesReturn?.customer?.email || "-",
    ];

    rightHeader = [
      "เลขที่เอกสาร / Document No.",
      "อ้างอิงถึง / Ref. Document",
      "วันที่ออกเอกสาร / Issue date",
      "เครดิต / Credit",
    ];

    rightInfo = [
      salesReturn?.document_id || "-",
      renderReferenceDocument(salesReturn?.reference_document_id),
      formatDate(salesReturn?.issue_date) || "-",
      salesReturn?.credit_day ? salesReturn?.credit_day + " วัน" : "-",
    ];
  } else {
    leftHeader = [
      "รหัสลูกค้า / Customer ID",
      "ชื่อลูกค้า / Customer Name",
      "ที่อยู่ / Address",
    ];

    leftInfo = [
      salesReturn?.contact_document_id || "-",
      contact?.contact_name || "-",
      renderAddressString(salesReturn?.customer?.billing_address || {}) || "",
    ];

    rightHeader = [
      "เลขที่เอกสาร / Document No.",
      "วันที่ส่งของ / Delivery Date",
      "วันที่รับคืน / Return Date",
      "อ้างอิงถึง / Ref. Document",
      "หมายเลขอ้างอิง / Ref. No.",
    ];

    rightInfo = [
      salesReturn?.document_id || "-",
      salesReturn?.delivery_date ? formatDate(salesReturn.delivery_date) : "-",
      salesReturn?.issue_date ? formatDate(salesReturn.issue_date) : "-",
      renderReferenceDocument(salesReturn?.reference_document_id),
      salesReturn?.external_ref_id || "-",
    ];
  }

  return (
    <Grid container sx={{ my: 1 }}>
      <Grid item xs={6}>
        {leftHeader.map((name, index) => (
          <Box sx={{ display: "flex" }} key={index}>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                fontWeight: 600,
                color: "#333333",
                flex: 1,
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                flex: 1,
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {leftInfo[index]}
            </Typography>
          </Box>
        ))}
      </Grid>
      <Grid item xs={6}>
        {rightHeader.map((name, index) => (
          <Box sx={{ display: "flex" }} key={index}>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                fontWeight: 600,
                color: "#333333",
                flex: 1,
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                flex: 1,
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {rightInfo[index]}
            </Typography>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default SalesReturnPDFInfo;
